export interface Book {
    original_filename: string;

    title?: string | null;
    authors: string[];
    edition?: string | null;
    publisher?: string | null;
    language?: string | null;

    sourceSha256?: string | null;
    storedPdfUri?: string | null;

    status: BookStatus;

    total_pages?: number | null;
    processedPages: number;
    totalChunks: number;
    size_mb?: number | null;

    errorMessage?: string | null;
    attempts: number;

    id: string;
    createdAt: Date;
    updatedAt: Date;
}

export enum BookStatus {
    UPLOADED = "uploaded",
    SPLITTING = "splitting",
    PROCESSING = "processing",
    READY = "ready",
    FAILED = "failed",
}
